import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export var Loading = function () {
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "loading-container", children: _jsxs("div", { className: "loading", children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {}), _jsx("span", {})] }) }) }));
};
